import React from 'react';
import PropTypes from 'prop-types';
import { merge } from 'lodash';
import NumericField from '../NumericField';

const integerMaskProps = {
  prefix: '',
  includeThousandsSeparator: false,
};

export default class IntegerField extends React.Component {
  static defaultProps = {
    maskProps: {},
  };

  static propTypes = {
    maskProps: PropTypes.object,
  };

  render() {
    const { maskProps, ...props } = this.props;

    return (
      <NumericField maskProps={merge({}, integerMaskProps, maskProps)} guide={false} {...props} />
    );
  }
}
